<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIyilestirmeTur from "@/models/StrIyilestirmeTur";
export default {
  mixins: [Api, Sabit, StrIyilestirmeTur],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("StrIyilestirmeTur", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.StrIyilestirmeTurData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIyilestirmeTur");
            }
          });
        } else {
          this.Update("StrIyilestirmeTur", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrIyilestirmeTurData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIyilestirmeTur");
            }
          });
        }
      }
    },
    Get() { },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIyilestirmeTur" size="lg" :title="this.AddEdit == 'Edit'
      ? 'Kaydı Düzenle'
      : 'Kayıt Ekle'
      " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">

          <forminput class="col-md-6" :FormDataType="FormDataType.Tur" :Value="FormData.Tur" :v="$v.FormData.Tur"
            @input="FormData.Tur = $event" />
          <forminput class="col-md-6" :FormDataType="FormDataType.Kod" :Value="FormData.Kod" :v="$v.FormData.Kod"
            @input="FormData.Kod = $event" />

        </div>
        <button class="btn btn-primary" type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
